"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BulkLoadModel = _interopRequireDefault(require("../models/BulkLoadModel"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _reactRouter = require("react-router");

var _AppUploadField = _interopRequireDefault(require("../../../../components/crud/AppUploadField"));

var _components = require("../../../../components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var NewBulkLoad = /*#__PURE__*/function (_React$Component) {
  _inherits(NewBulkLoad, _React$Component);

  function NewBulkLoad(props) {
    var _this;

    _classCallCheck(this, NewBulkLoad);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NewBulkLoad).call(this, props));
    _this.formHandler = new _components.FormHandler(_assertThisInitialized(_this), new _BulkLoadModel["default"]({
      name: '',
      bulkFile: ''
    }));
    return _this;
  }

  _createClass(NewBulkLoad, [{
    key: "_onSuccess",
    value: function _onSuccess(data) {
      var load = data.data;
      return this.props.history.push('/tools/bulk-load/details/' + load.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var formHandler = this.formHandler;
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        style: {
          padding: '0 5% 5% 5%',
          textAlign: 'center',
          border: '1px solid transparent'
        }
      }, _react["default"].createElement(_components.FormSubmitWrapper, {
        buttonText: 'Upload',
        formHandler: formHandler,
        to: "/tools/bulk-load",
        onSuccess: function onSuccess(data) {
          return _this2._onSuccess(data);
        }
      }, _react["default"].createElement(_components.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "Name",
        type: "text",
        name: "name",
        value: this.state.record.name,
        errors: formHandler.getErrors(),
        handler: formHandler
      }), _react["default"].createElement(_AppUploadField["default"], {
        label: '*Upload XLSX file',
        name: 'bulkFile',
        handler: formHandler,
        errors: formHandler.getErrors(),
        accept: ".xlsx",
        value: this.state.record.bulkFile
      }), _react["default"].createElement("p", null, "Example file can be downloaded ", _react["default"].createElement("a", {
        href: require('../../../../assets/example_file.xlsx'),
        style: {
          fontWeight: 'bold'
        },
        target: "_blank",
        download: true
      }, "here")))));
    }
  }]);

  return NewBulkLoad;
}(_react["default"].Component);

var _default = (0, _reactRouter.withRouter)(NewBulkLoad);

exports["default"] = _default;